import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import RedirectNewForm from './forms/CreateRedirectForm';
import {fetchSites} from '../sites/thunks';
import {
    fetchStatuses,
    createRedirect
} from './thunks';

import {getFormValues} from 'redux-form';

class RedirectCreate extends Component {

    componentWillMount() {
        this.props.fetchStatuses();
        this.props.fetchSites();
    }

    handleCreateRedirectSubmit(formProps) {
        this.props.createRedirect(formProps);
    }

    render() {
        return (
            this.props.loading !== true &&
            <RedirectNewForm
                redirect={this.props.redirect}
                statuses={this.props.statuses}
                sites={this.props.sites}
                classes={this.props.classes}
                handleFormSubmit={this.handleCreateRedirectSubmit.bind(this)}
                touched={this.props.touched}
                loading={this.props.loading}
            />
        )
    }
}

const mapStateToProps = state => ({
    statuses: state.redirects.statuses,
    loading: state.layout.ajaxCallsInProgress > 0,
    touched: state.redirects.touched,
    sites: state.sites.all,
    redirect: getFormValues('RedirectEditForm')(state),
});

export default connect(mapStateToProps, {
    fetchStatuses,
    fetchSites,
    createRedirect,
})(withStyles(styles)(RedirectCreate));


// WEBPACK FOOTER //
// ./src/containers/redirects/RedirectCreate.jsx